import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/configureStore";
import { useUpdateSessionLayoutMutation } from "../../api/api";
import { useJoinData, useSession } from "../../api/helpers";
import { getIsPublishing } from "../selectors";
import { setComposedLayout } from "../sessionSlice";
import useStreamLayout from "../useStreamLayout";

const useUpdateComposedLayout = (streams: OT.Stream[]) => {
  const session = useSession();
  const dispatch = useAppDispatch();
  const isPublishing = useAppSelector(getIsPublishing(session?.sessionId));
  const joinData = useJoinData();
  const [updateLayout] = useUpdateSessionLayoutMutation();

  const composedLayout = useStreamLayout(streams, 1280, 720);

  useEffect(() => {
    if (composedLayout && session?.sessionId) {
      dispatch(setComposedLayout(session.sessionId, composedLayout));
    }
  }, [composedLayout, dispatch, session?.sessionId]);

  useEffect(() => {
    if (
      composedLayout &&
      isPublishing &&
      session?.sessionId &&
      (session?.isKeynote || joinData?.isRecorded) &&
      session?.status === "InProgress"
    ) {
      updateLayout({ sessionId: session.sessionId, layout: composedLayout });
    }
  }, [
    composedLayout,
    isPublishing,
    joinData?.isRecorded,
    session?.isKeynote,
    session?.sessionId,
    session?.status,
    updateLayout,
  ]);
};

export default useUpdateComposedLayout;
